import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import DataTable from "components/common/DataTable";
import ContentLoading from "components/common/ContentLoading";
import DataTableApiResponse from "interfaces/DataTableApiResponse";
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import apifetch from 'utils/apifetch';
import extractErrorMessage from "utils/extractErrorMessage";
import getBaseUrl from "utils/getBaseUrl";
import SectionSummary from '../../interfaces/SectionSummary';

interface State {
    isLoading: boolean;
    //isAdmin: boolean;
    data: SectionSummary[];
    spinner: boolean;
    errorMessage?: string;
}

export default class Index extends React.Component<RouteComponentProps<{}>, State> {
    private baseUrl: string;
    private mainDataTableRef: React.RefObject<DataTable>;
    private dataTableRef: React.RefObject<HTMLTableElement>;

    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            isLoading: true,
            data: [],
            spinner: true,
            errorMessage: undefined,
        };

        this.baseUrl = getBaseUrl();
        this.mainDataTableRef = React.createRef();
        this.dataTableRef = React.createRef();

        this.dataTableData = this.dataTableData.bind(this);
        this.dataTableDataFilter = this.dataTableDataFilter.bind(this);
        this.handleDataTableDraw = this.handleDataTableDraw.bind(this);
        this.deleteSection = this.deleteSection.bind(this);
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading />
                </div>
            );
        }

        return <div className="container">
            <div className="animated fadeIn">
                <Breadcrumb>
                    <BreadcrumbLink to="/">Home</BreadcrumbLink>
                    <BreadcrumbLink isActive={true}>Categories</BreadcrumbLink>
                </Breadcrumb>
                {this.state.errorMessage && (
                    <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                )}

                <div className="card card--datatables">
                    <div className="card-block">
                        <h2 className="card__title">Categories</h2>
                        <div className="datatable-wrapper">
                            <DataTable
                                ajaxUrl={this.baseUrl + "api/sections/summary"}
                                useAuth={true}
                                ajaxData={this.dataTableData}
                                ajaxDataFilter={this.dataTableDataFilter}
                                onDraw={this.handleDataTableDraw}
                                ref={this.mainDataTableRef}
                                stateSave={true}
                            >
                                <thead>
                                    <tr>
                                        <th style={{ width: "8%" }}>ID</th>
                                        <th style={{ width: "18%" }}>Category Name</th>
                                        <th style={{ width: "12%" }}>Code</th>
                                        <th style={{ width: "24%" }}>Description</th>
                                        <th style={{ width: "9%" }}>Price 1</th>
                                        <th style={{ width: "9%" }}>Price 2</th>
                                        <th style={{ width: "9%" }}>Price 3</th>
                                        <th style={{ width: "11%" }}>Price 4</th>
                                    </tr>
                                </thead>
                                <tbody>
                                </tbody>
                            </DataTable>
                            {this.state.spinner ?
                                <ContentLoading />
                                :
                                <table className="d-none" ref={this.dataTableRef}>
                                    <tbody>
                                        {this.state.data.map((item, index) =>
                                            <tr key={item.id}
                                                id={`row-${item.id}`}
                                            >
                                                <td>{item.id}</td>
                                                <td>{item.name}</td>
                                                <td>{item.code}</td>
                                                <td>{item.description}</td>
                                                <td>{item.listPricePercentage != null ? item.listPricePercentage + ' %' : ''}</td>
                                                <td>{item.ourListPricePercentage != null ? item.ourListPricePercentage + ' %' : ''}</td>
                                                <td>{item.marketCostPercentage != null ? item.marketCostPercentage + ' %' : ''}</td>
                                                <td>{item.price4Percentage != null ? item.price4Percentage + ' %' : ''}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }

    public componentDidMount() {
        this.setState({
            isLoading: false
        });

        document.title = "Categories - " + SITE_NAME;
    }

    private dataTableData(data: any) {
        let sortFields = [
            "id",
            "name",
            "code",
            "description",
            "listPricePercentage",
            "ourListPricePercentage",
            "marketCostPercentage",
            "price4Percentage"];

        let newData = {
            pageNumber: Math.floor(data.start / data.length) + 1,
            pageSize: data.length,
            sortField: sortFields[data.order[0].column],
            sortDirection: data.order[0].dir === "asc"
                ? 1
                : 2,
            search: data.search.value,
            draw: data.draw,
        }

        return newData;
    }

    private dataTableDataFilter(data: string) {
        var json = JSON.parse(data) as DataTableApiResponse<SectionSummary>;

        this.setState({
            data: json.items,
            spinner: false,
        });

        let tableData = [];
        let $tr = $(this.dataTableRef.current!).find("tr");
        for (let i = 0; i < $tr.length; i++) {
            let $td = $tr.eq(i).find("td");
            let rowData = [];
            for (let j = 0; j < $td.length; j++) {
                rowData.push($td.eq(j).clone(true, true).html());
            }
            tableData.push(rowData);
        }

        let newData = {
            draw: json.draw,
            recordTotal: json.metadata.totalItemCount,
            recordsFiltered: json.metadata.totalItemCount,
            data: tableData,
        };

        return JSON.stringify(newData);
    }

    //private handleDataTableDraw(dataTable: any) {
    //    $(dataTable).find("a:not([href='#'])").click(e => {
    //        e.preventDefault();
    //        this.props.history.push($(e.currentTarget).attr("href")!);
    //    });
    //    $(dataTable).find(".btn-delete").click(e => {
    //        e.preventDefault();
    //        this.deleteSection(parseInt($(e.currentTarget).attr("data-id")!, 10));
    //    });
    //}

    private handleDataTableDraw(dataTable: any) {
        $(dataTable).off("click", "tr");
        $(dataTable).find("a:not([href='#'])").off("click");
        $(dataTable)
            .find("tbody tr")
            .css("cursor", "pointer");

        $(dataTable)
            .find("a:not([href='#'])")
            .on("click", (e) => {
                e.preventDefault();
                this.props.history.push($(e.currentTarget).attr("href")!);
            });

        $(dataTable).on("click", "tr", (e) => {
            const rowId = $(e.currentTarget).find("td").first().text().trim();
            if (rowId) {
                this.props.history.push(`/sections/${rowId}`);
            }
        });
    }

    private async deleteSection(id: number) {
        this.setState({ errorMessage: undefined });
        if (window.confirm('Are you sure you wish to delete this item?')) {
            let response = await apifetch(`sections/${id}`, {
                method: "DELETE",
            }, true);
            if (response.ok) {
                this.mainDataTableRef.current!.reload();
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({ errorMessage: errorText });
            }
        }
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/sections/Index.tsx